
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["icon",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","width":"12","height":"12","viewBox":"0 0 12 12","stroke":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"close (1)"}},[_c('g',{attrs:{"data-name":"close_1_","fill":"#fff"}},[_c('path',{attrs:{"data-name":"Path 36630","d":"M2.446 10.647a.894.894 0 01-.621-.2.825.825 0 010-1.192l7.426-7.178a.9.9 0 011.236.04.824.824 0 01.041 1.11l-7.47 7.219a.894.894 0 01-.612.2z"}}),_c('path',{attrs:{"data-name":"Path 36631","d":"M9.861 10.646a.89.89 0 01-.612-.245L1.824 3.225a.826.826 0 01.1-1.192.9.9 0 011.138 0l7.469 7.176a.825.825 0 01.041 1.195l-.041.039a.9.9 0 01-.665.2z"}})])])])
          )
        }
      }
    